module.exports = __webpack_public_path__ + "static/media/droopy_upper.7bd75b0b.svg";